import { useCallback } from 'react';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { createProEmbeddedCheckoutSession } from '../helpers/proSubscriptionApi';

export type PurchaseProResult =
  | { success: true; session: { clientSecret: string; sessionId: string } }
  | { success: false; error: string };

export function usePurchaseProSubscription() {
  const apiClient = useApiClient();

  const purchaseProSubscription = useCallback(async (
    billingInterval: 'month' | 'year',
  ): Promise<PurchaseProResult> => {
    try {
      const session = await createProEmbeddedCheckoutSession(
        apiClient as (endpoint: string, options?: Record<string, unknown>) => Promise<{ status: number; data: unknown }>,
        billingInterval,
      );
      return { success: true, session };
    } catch (err) {
      return { success: false, error: err instanceof Error ? err.message : 'Failed to start checkout' };
    }
  }, [apiClient]);

  return { purchaseProSubscription };
}
